// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3TgRX","ranges":"BmiRanges_ranges__1Y1rM"};